module.exports = __webpack_public_path__ + "img/e_2_10_r.7fccc07d.png";